import { render, staticRenderFns } from "./Pinjaman-Mobile.vue?vue&type=template&id=7068ded7&scoped=true"
import script from "./Pinjaman-Mobile.vue?vue&type=script&lang=js"
export * from "./Pinjaman-Mobile.vue?vue&type=script&lang=js"
import style0 from "./Pinjaman-Mobile.vue?vue&type=style&index=0&id=7068ded7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068ded7",
  null
  
)

export default component.exports